import React from 'react';

import compose from "recompose/compose";
import User from "@lib/classes/User";
import Route from "@lib/classes/Route";
import withRenderProcess from '@gqlapp/base/renderProcess';
import Head from "@lib/classes/Head";
import Base from '@lib/classes/PageLayout';

export const withRoute = (Component: any) => {
	return (({ currentUser, graphqlRoute, ...props}: any) => {
		// console.warn('########','route', '#########', graphqlRoute)
		Object.assign(props, {
			currentUser: User.instanse(currentUser),
			route: Route.instanse(graphqlRoute)
		})

		const webType = props?.webType || 'web';

		const $self: any = props?.$self;

		const preload = $self?.preload || [];
		const components = $self?.getPopup([webType]) || [];


		/**
		 * Load client withPreProps
		 */
		const Render = compose(...preload, ...components, withRenderProcess)
			// @ts-ignore
		((props)=>{
			return React.createElement(Head, props, React.createElement(Base, props, React.createElement(Component, props)))
		})

		// @ts-ignore
		return React.createElement(Render, props);
	});
};

export default withRoute;
